<template>
  <div>
    <div class="mb-1" v-if="quickLinkData.program_proposal">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/program_proposals/${eventDatas.proposal_id}`)"
      >
       Program Proposal
      </a>
    </div>
    <!-- <div class="mb-1" v-if="quickLinkData.how_to_apply">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(type === 'summer_research' ? '/web/msri/scientific/summer-research-in-mathematics' : '/web/msri/scientific/member-application')"
      >
        How to Apply
      </a>
    </div> -->
    <div class="mb-1" v-if="quickLinkData.members_present">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/members`)"
      >
        <b-badge variant="primary">{{quickLinkData.members_count}}</b-badge> Members
      </a>
    </div>
    <div class="mb-1" v-if="quickLinkData.visits_present">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/visits`)"
      >
        <b-badge variant="primary">{{quickLinkData.visits_count}}</b-badge> Visits
      </a>
    </div>
    <div class="mb-1" v-if="quickLinkData.exit_surveys_present">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/exit_surveys`)"
      >
        <b-badge variant="primary">{{quickLinkData.exit_surveys_count}}</b-badge> Exit Surveys
      </a>
    </div>
    <div class="mb-1" v-if="quickLinkData.discussion_present">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/discussions`)"
      >
        <b-badge variant="primary">{{quickLinkData.discussions_count}}</b-badge> Discussions
      </a>
    </div>
    <div class="mb-1" v-if="quickLinkData.acceptance_link_present">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/accept`)"
      >
        Acceptance Link
      </a>
    </div>
    <div class="mb-1" v-if="quickLinkData.schedule_and_links_present && type === 'programs'">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/programs/${this.$route.params.id}/announcements`)"
      >
        Schedule and Important Links
      </a>
    </div>
  </div>
  </template>

  <script>
  import mixin from '@/utils/mixin.js'

  export default {
    name: 'ProgramQuickLinkSection',
    mixins: [mixin],
    props: ['type', 'quick-link-data', 'eventDatas']
  }
  </script>
